import { useState } from "react";
import { Reveal, SectionMark } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
    "w-full border-b border-white/15 bg-transparent py-3 text-base text-bone placeholder:text-silver/50 outline-none transition-colors duration-300 focus:border-bronze";

export const ContactForm = () => {
    const [form, setForm] = useState({ name: "", phone: "", message: "" });
    const [state, setState] = useState("idle");

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setState("sending");
        try {
            const res = await fetch(`${API}/contact-messages`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error();
            setState("done");
        } catch {
            setState("error");
        }
    };

    return (
        <section
            data-testid="contact-form-section"
            className="border-t border-white/[0.07] px-5 py-24 md:px-10 md:py-32"
        >
            <div className="mx-auto grid max-w-[1400px] gap-12 md:grid-cols-2 md:gap-20">
                <div>
                    <Reveal>
                        <SectionMark>( Pišite nam )</SectionMark>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-6 font-display text-3xl font-light leading-tight tracking-tight text-bone md:text-5xl">
                            Imate pitanje?
                            <br />
                            <span className="italic text-bronze">Javite nam se.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-silver">
                            Pošaljite poruku putem obrasca ili nas nazovite —
                            odgovaramo što prije.
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.15}>
                    {state === "done" ? (
                        <p
                            data-testid="contact-form-success"
                            className="border border-bronze/40 p-8 font-display text-2xl font-light italic text-bronze"
                        >
                            Poruka zaprimljena. Hvala!
                        </p>
                    ) : (
                        <form onSubmit={submit} data-testid="contact-form" className="space-y-8">
                            <div>
                                <label htmlFor="cf-name" className="mb-1 block text-[10px] font-medium uppercase tracking-[0.3em] text-silver">
                                    Ime i prezime
                                </label>
                                <input
                                    id="cf-name"
                                    data-testid="contact-name-input"
                                    required
                                    minLength={2}
                                    value={form.name}
                                    onChange={set("name")}
                                    className={inputCls}
                                />
                            </div>
                            <div>
                                <label htmlFor="cf-phone" className="mb-1 block text-[10px] font-medium uppercase tracking-[0.3em] text-silver">
                                    Broj telefona
                                </label>
                                <input
                                    id="cf-phone"
                                    data-testid="contact-phone-input"
                                    required
                                    minLength={6}
                                    type="tel"
                                    value={form.phone}
                                    onChange={set("phone")}
                                    className={inputCls}
                                />
                            </div>
                            <div>
                                <label htmlFor="cf-msg" className="mb-1 block text-[10px] font-medium uppercase tracking-[0.3em] text-silver">
                                    Poruka
                                </label>
                                <textarea
                                    id="cf-msg"
                                    data-testid="contact-message-input"
                                    required
                                    minLength={5}
                                    rows={4}
                                    maxLength={2000}
                                    value={form.message}
                                    onChange={set("message")}
                                    className={`${inputCls} resize-none`}
                                />
                            </div>
                            {state === "error" && (
                                <p data-testid="contact-form-error" className="text-sm text-red-400">
                                    Došlo je do greške — pokušajte ponovno.
                                </p>
                            )}
                            <button
                                type="submit"
                                data-testid="contact-submit-button"
                                disabled={state === "sending"}
                                className="bg-bone px-12 py-4 text-[11px] font-semibold tracking-[0.26em] text-[#0a0a0b] transition-colors duration-300 hover:bg-bronze disabled:opacity-50"
                            >
                                {state === "sending" ? "ŠALJEM…" : "POŠALJI PORUKU"}
                            </button>
                        </form>
                    )}
                </Reveal>
            </div>
        </section>
    );
};
